module.exports = __webpack_public_path__ + "img/135.30dee028.svg";